import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import DetallesPasajeros from './DetallesPasajeros';
import SearchBar from '../SearchBar';
import { exportToExcel } from './ExcelExporter';
import { RiFileExcel2Line } from 'react-icons/ri';

const TablaPasajeros = () => {
    const [pasajeros, setPasajeros] = useState([]);
    const [filteredPasajeros, setFilteredPasajeros] = useState(pasajeros);

    const handleSearch = (searchTerm) => {
        if (!searchTerm.trim()) {
            setFilteredPasajeros(pasajeros);
        } else {
            const filtered = pasajeros.filter((pasajero) => {
                const nombreCompleto = formatName(pasajero.name, pasajero.last_name).toLowerCase();
                const email = formatValue(pasajero.email).toLowerCase();
                const registro = formatDate(pasajero.register_date).toLowerCase();
                const ultimaConexion = formatDate(pasajero.last_log_date).toLowerCase();
                const id = pasajero.user_id.toLowerCase();

                return (
                    id.includes(searchTerm.toLowerCase()) ||
                    nombreCompleto.includes(searchTerm.toLowerCase()) ||
                    email.includes(searchTerm.toLowerCase()) ||
                    registro.includes(searchTerm.toLowerCase()) ||
                    ultimaConexion.includes(searchTerm.toLowerCase())
                );
            });
            setFilteredPasajeros(filtered);
        }
    };

    useEffect(() => {
        setFilteredPasajeros(pasajeros);
    }, [pasajeros]);

    useEffect(() => {
        const fetchPasajerosData = async () => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_API_URL_PASAJEROS,
                    {
                        headers: {
                            "x-hasura-admin-secret": process.env.REACT_APP_API_KEY,
                        },
                    }
                );
                setPasajeros(response.data.user);
            } catch (error) {
                console.error("Error fetching passengers data:", error);
            }
        };
        fetchPasajerosData();
    }, []);

    const formatDate = (timestamp) => {
        if (!timestamp) {
            return "Sin datos";
        }
        const date = new Date(parseInt(timestamp));
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    };

    const formatValue = (value) => {
        return value !== null ? value : "N/A";
    };
    const formatRating = (rating) => {
        return rating !== null ? rating : "0";
    };
    const formatName = (firstName, lastName) => {
        if (firstName && lastName !== undefined && firstName && lastName !== null) {
            const fullName = `${firstName} ${lastName}`;
            return fullName.toUpperCase();
        } else if (firstName) {
            return firstName.toUpperCase();
        } else if (lastName) {
            return lastName.toUpperCase();
        } else {
            return "Sin nombre";
        }
    };

    const columns = [
        {
            name: 'Id',
            selector: 'user_id',
            sortable: true,
            width: '240px',
            cell: row => (
                <strong className='font-custom overflow-hidden' style={{ display: 'block', fontSize: '1rem', whiteSpace: 'nowrap' }}>
                    {row.user_id}
                </strong>
            ),
        },
        {
            name: 'Nombre',
            selector: row => formatName(row.name, row.last_name),
            width: '240px',
            sortable: true,
            cell: row => (
                <div className='font-custom overflow-hidden' style={{ display: 'block', fontSize: '1rem', whiteSpace: 'nowrap' }}>
                    {row.name || 'N/A'} {row.last_name}
                </div>
            ),
        },
        {
            name: 'Email',
            selector: row => formatValue(row.email),
            sortable: true,
            width: '240px',
        },
        {
            name: 'Registro',
            selector: row => formatDate(row.register_date),
            sortable: true,
            width: '160px',
        },
        {
            name: 'Última Conexión',
            selector: row => formatDate(row.last_log_date),
            sortable: true,
            width: '220px',
        },
        {
            name: 'Calificación',
            selector: row => formatRating(row.rating),
            sortable: true,
            width: '165px',
            cell: row =>
                <div className='font-custom' style={{ display: 'block', fontSize: '1rem' }}>{row.rating || 'N/A'}</div>,
        },
        {
            name: 'Opciones',
            selector: 'options',
            width: '130px',
            cell: row => (
                <div className="flex items-center">
                    <DetallesPasajeros rowData={row} />
                </div>
            ),
            ignoreRowClick: true,
        },
    ];

    const columnConfig = [
        { label: 'ID', key: 'user_id' },
        { label: 'Nombre', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Fecha de registro', key: 'register_date' },
        { label: 'Ultima conexion', key: 'last_log_date' },
        { label: 'Calificacion', key: 'rating' },
    ];

    const exportToExcelLocal = () => {
        exportToExcel(filteredPasajeros, columnConfig);
    };

    return (
        <div className='ml-30 mr-30 mt-10 mb-4'>
            <SearchBar onSearch={handleSearch} />
            <button
                className='bg-green-600 p-2 text-white font-bold mb-2 flex items-center space-x-2 hover:bg-green-900'
                onClick={exportToExcelLocal}
            >
                <RiFileExcel2Line className='text-2xl mr-1' />
                Descargar Excel
            </button>
            <DataTable
                columns={columns}
                data={filteredPasajeros}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                customStyles={{
                    rows: {
                        style: {
                            borderTop: '1px solid #CBD5E0',
                        },
                    },
                    headCells: {
                        style: {
                            fontSize: '1.25rem',
                            textAlign: 'center',
                        },
                    },
                    cells: {
                        style: {
                            marginTop: '1rem',
                            marginBottom: '1rem',
                            fontSize: '1rem',
                        },
                    }
                }}
            />
        </div>
    );
}

export default TablaPasajeros;